/**
 *
 * Disclaimer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppContainer from 'components/AppContainer';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { arrayToSentence } from 'utils/stringUtils';
import _isEmpty from 'lodash/isEmpty';

const styles = theme => ({
  root: {
    padding: '20px !important',
    boxShadow: 'none !important',
    border: '1px solid #E2E2E2',
    borderRadius: 8,
    color: theme.palette.primary.contrastText,
    background: '#fff',
    fontSize: 14,
    lineHeight: 1.57,
    '& p, span': {
      color: theme.palette.primary.contrastText,
      fontSize: 14,
      lineHeight: 1.57,
    },
  },
  content: {
    boxShadow: 'none',
  },
  disclaimer: {
    fontWeight: 600,
  },
});

function Disclaimer(props) {
  const {
    classes,
    type,
    person = [],
    organization = [],
    vendor = [],
    name = '',
    isGuestBlog,
  } = props;
  const combinedData = [...person, ...organization];
  const values = combinedData
    .filter(item => item.fields)
    .map(data => data.fields.name);
  const personOrgsAndVendors = arrayToSentence([...values, ...vendor]);
  if (_isEmpty(personOrgsAndVendors)) return null;
  const referenceLabel =
    [...values, ...vendor].length > 1 ? 'who are' : 'who is';
  const calledLabel = !_isEmpty(name) ? `called ${name}` : '';
  const disclaimertext = !isGuestBlog
    ? `The ${type}
  ${calledLabel} and artwork above are the property of
  ${personOrgsAndVendors} ${referenceLabel} not affiliated with
  CredibleMind, Inc.`
    : `Ambassador blogs offer unique perspectives based on personal experience and are not the opinion of CredibleMind, Inc.`;
  return (
    <AppContainer>
      <Grid item xs={12} className={classes.root}>
        <Paper className={classes.content}>
          {!isGuestBlog && (
            <span className={classes.disclaimer}>Disclaimer:</span>
          )}{' '}
          {disclaimertext}
        </Paper>
      </Grid>
    </AppContainer>
  );
}

Disclaimer.propTypes = {
  classes: PropTypes.object,
  type: PropTypes.string,
  person: PropTypes.array,
  organization: PropTypes.array,
  vendor: PropTypes.array,
  name: PropTypes.string,
  isGuestBlog: PropTypes.bool,
};

Disclaimer.defaultProps = {
  isGuestBlog: false,
};

export default withStyles(styles)(Disclaimer);
